import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronLeft } from 'lucide-react';

const Privacy = () => {
  return (
    <div data-testid="privacy-page" className="min-h-screen pt-32 pb-24 px-6 md:px-12">
      <div className="max-w-4xl mx-auto">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors mb-8"
        >
          <ChevronLeft className="h-4 w-4" />
          Tornar a l'inici
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-foreground mb-8">
            Política de Privacitat
          </h1>

          <div className="prose prose-lg max-w-none">
            <p className="text-muted-foreground mb-8">
              Última actualització: {new Date().toLocaleDateString('ca-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">1. Responsable del Tractament</h2>
              <p className="text-foreground/80 mb-4">
                D'acord amb el Reglament General de Protecció de Dades (RGPD), l'informem que les dades personals recollides a través d'aquest lloc web seran tractades per:
              </p>
              <ul className="list-disc pl-6 text-foreground/80 space-y-2">
                <li><strong>Responsable:</strong> Teresa Porredon Solé</li>
                <li><strong>NIF:</strong> 38531828C</li>
                <li><strong>Adreça:</strong> Carrer Capità Arenas, 25, Baixos, 08034 Barcelona</li>
                <li><strong>Telèfon:</strong> 932 040 216</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">2. Finalitat del Tractament</h2>
              <p className="text-foreground/80 mb-4">
                Les dades personals que ens faciliti seran tractades amb les següents finalitats:
              </p>
              <ul className="list-disc pl-6 text-foreground/80 space-y-2">
                <li>Gestionar les comandes i compres realitzades a través del lloc web</li>
                <li>Tramitar els pagaments i emetre factures</li>
                <li>Gestionar la recollida de productes</li>
                <li>Respondre a les seves consultes i sol·licituds</li>
                <li>Complir amb les obligacions legals aplicables</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">3. Legitimació</h2>
              <p className="text-foreground/80 mb-4">
                La base legal per al tractament de les seves dades és:
              </p>
              <ul className="list-disc pl-6 text-foreground/80 space-y-2">
                <li>L'execució d'un contracte de compravenda</li>
                <li>El compliment d'obligacions legals</li>
                <li>El seu consentiment express quan sigui necessari</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">4. Conservació de les Dades</h2>
              <p className="text-foreground/80 mb-4">
                Les dades personals es conservaran durant el temps necessari per complir amb la finalitat per a la qual es van recollir i per determinar les possibles responsabilitats que puguin derivar-se d'aquesta finalitat i del tractament de les dades. Posteriorment, es conservaran bloquejades durant els terminis establerts per la legislació aplicable.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">5. Destinataris de les Dades</h2>
              <p className="text-foreground/80 mb-4">
                Les seves dades podran ser comunicades als següents destinataris:
              </p>
              <ul className="list-disc pl-6 text-foreground/80 space-y-2">
                <li>Entitats financeres per a la gestió dels pagaments (Stripe)</li>
                <li>Organismes públics quan existeixi una obligació legal</li>
              </ul>
              <p className="text-foreground/80 mt-4">
                No es realitzaran transferències internacionals de dades.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">6. Drets dels Usuaris</h2>
              <p className="text-foreground/80 mb-4">
                Vostè té dret a:
              </p>
              <ul className="list-disc pl-6 text-foreground/80 space-y-2">
                <li><strong>Accés:</strong> Sol·licitar informació sobre les dades que tractem</li>
                <li><strong>Rectificació:</strong> Sol·licitar la correcció de dades inexactes</li>
                <li><strong>Supressió:</strong> Sol·licitar l'eliminació de les seves dades</li>
                <li><strong>Oposició:</strong> Oposar-se al tractament de les seves dades</li>
                <li><strong>Limitació:</strong> Sol·licitar la limitació del tractament</li>
                <li><strong>Portabilitat:</strong> Rebre les seves dades en format estructurat</li>
              </ul>
              <p className="text-foreground/80 mt-4">
                Pot exercir aquests drets contactant-nos al telèfon 932 040 216 o a l'adreça Carrer Capità Arenas, 25, Baixos, 08034 Barcelona.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">7. Reclamació</h2>
              <p className="text-foreground/80 mb-4">
                Té dret a presentar una reclamació davant l'Agència Espanyola de Protecció de Dades (www.aepd.es) si considera que el tractament de les seves dades no s'ajusta a la normativa vigent.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">8. Seguretat de les Dades</h2>
              <p className="text-foreground/80 mb-4">
                Estel Regals ha adoptat les mesures tècniques i organitzatives necessàries per garantir la seguretat i integritat de les dades personals, així com per evitar la seva pèrdua, alteració i/o accés per part de tercers no autoritzats.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl font-medium text-foreground mb-4">9. Actualitzacions</h2>
              <p className="text-foreground/80 mb-4">
                Aquesta Política de Privacitat pot ser actualitzada periòdicament. Li recomanem revisar-la regularment per estar informat de qualsevol canvi.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Privacy;